"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const system_1 = require("@mui/system");
const colors_1 = require("../../../styles/colors");
const styled_1 = __importDefault(require("@emotion/styled"));
const StyledLink = (0, styled_1.default)(material_1.Link) `
  display: flex;
  align-items: center;
`;
const StyledHomeOutlined = (0, styled_1.default)(icons_material_1.HomeOutlined) `
  margin-right: 4px;
`;
const Breadcrumb = (props) => {
    var _a;
    return ((0, jsx_runtime_1.jsx)(system_1.Stack, Object.assign({ direction: "row", spacing: 1, alignItems: "center" }, { children: (0, jsx_runtime_1.jsxs)(material_1.Breadcrumbs, Object.assign({ "aria-label": "breadcrumb", sx: { fontSize: '10px' } }, { children: [(0, jsx_runtime_1.jsxs)(StyledLink, Object.assign({ underline: "hover", color: colors_1.$grey30, href: "/" }, { children: [(0, jsx_runtime_1.jsx)(StyledHomeOutlined, { htmlColor: colors_1.$primaryBlack, fontSize: "inherit", "data-testid": "home-icon" }), "Home"] })), (_a = props.routes) === null || _a === void 0 ? void 0 : _a.map((r, index) => {
                    const isEnd = index === props.routes.length - 1;
                    return ((0, jsx_runtime_1.jsx)(material_1.Link, Object.assign({ underline: "hover", href: r.path, color: isEnd ? colors_1.$primaryNavy : colors_1.$grey30, "aria-current": isEnd ? 'page' : false }, { children: r.breadcrumb }), r.breadcrumb));
                })] })) })));
};
exports.Breadcrumb = Breadcrumb;
